<template>
  <div ref="footer" class="footer-frame">
    <div class="contact-fbg" v-if="isPhoneSize">
      <div class="h1">联系我们</div>
      <div class="contact-k">
        <p>
          <span><img src="../assets/images/newhome/bf02.svg" alt="">byepest@envu.com</span>
          <span class="ml"><img src="../assets/images/newhome/bf01.svg" alt="">400-188-8282</span>
        </p>
        <a href="javascript:;" @click="weixinLink"><img src="../assets/images/newhome/f07.png" alt="" style="height: 18px;"></a>
        <a href="https://weibo.com/u/6753773401" target="_blank"><img src="../assets/images/newhome/f06.png" alt="" style="height: 18px;"></a>
        <a href="https://v.douyin.com/i8awfnsd/ 8@3.com" target="_blank"><img src="../assets/images/newhome/f05.png" alt="" style="height: 18px;"></a>
        <a href="https://www.zhihu.com/org/bai-er-chong-chong-bai-bai" target="_blank"><img src="../assets/images/newhome/f04.png" alt="" style="height: 20px;"></a>
        <a href="https://www.xiaohongshu.com/user/profile/61307b320000000002019fcc?xhsshare=CopyLink&appuid=5b5214c711be102747b8f1f9&apptime=1703150384" target="_blank"><img src="../assets/images/newhome/f03.png" alt="" style="height: 18px;"></a>
      </div>
    </div>
    <div class="foot-w clearfix">
      <img src="../assets/images/newlogo/logoz.svg" alt="" class="logo">
      <ul v-if="!isPhoneSize">
        <li>
          <a href="javascript:;" class="left">品牌与服务</a>
          <a href="javascript:;" class="left" @click="wikiLink">虫害百科</a>
          <a href="javascript:;" class="left" @click="sqLink">虫虫社区</a>
          <a href="javascript:;" class="left" @click="weixinLinkzx">个人中心</a>
        </li>
        <li class="contact">
          <div class="h1">联系我们</div>
          <div class="contact-k">
            <img src="../assets/images/newhome/wx_qrcode.png" alt="" class="wxcode">
            <div class="rt">
              <a href="javascript:;" @click="weixinLink"><img src="../assets/images/newhome/bf07.png" alt=""></a>
              <a href="https://weibo.com/u/6753773401" target="_blank"><img src="../assets/images/newhome/bf06.png" alt=""></a>
              <a href="https://v.douyin.com/i8awfnsd/ 8@3.com" target="_blank"><img src="../assets/images/newhome/bf05.png" alt=""></a>
              <a href="https://www.zhihu.com/org/bai-er-chong-chong-bai-bai" target="_blank"><img src="../assets/images/newhome/bf04.png" alt=""></a>
              <a href="https://www.xiaohongshu.com/user/profile/61307b320000000002019fcc?xhsshare=CopyLink&appuid=5b5214c711be102747b8f1f9&apptime=1703150384" target="_blank"><img src="../assets/images/newhome/bf03.png" alt=""></a>
              <p>
                <span><img src="../assets/images/newhome/bf02.png" alt="">byepest@envu.com</span>
                <span class="ml"><img src="../assets/images/newhome/bf01.png" alt="">400-188-8282</span>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="foot">
      <div class="foot-w">
          <a id="footer_a_linkRouter_12" href="https://www.byepest.com/terms" @click.prevent="linkRouter('/terms')">服务协议</a>
          <span v-if="isPhoneSize">|</span>
          <a id="footer_a_linkRouter_13" href="https://www.byepest.com/privacy" @click.prevent="linkRouter('/privacy')">个人信息保护政策</a>
          <span v-if="isPhoneSize">|</span>
          <a id="footer_a_linkRouter_13" href="https://beian.miit.gov.cn">网站备案声明</a>
          <span class="mr">© 2018 安蔚优环境科技（上海）有限公司 版权所有<br v-if="isPhoneSize">沪ICP备2022022077号-1</span><span>上海市静安区昌平路363号1幢4层04-115室</span>
      </div>
    </div>
    <el-dialog
      title=""
      top="20vh"
      :visible.sync="weixinDialogImg"
      class="weixin-dialog-img">
      <div class="con" v-if="codeImg == ''">
        <img v-lazy="require('@/assets/images/newhome/404.png')" style="width: 50%; height: auto;" />
        <p style="color: #4D4CC1;">服务即将上线，敬请期待</p>
      </div>
      <div class="con" v-else>
        <img v-lazy="require('@/assets/images/newhome/' + codeImg + '.png')" />
        <p>请微信扫码查看相关详情</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    isPhoneSize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      weixinDialogImg: false,
      codeImg: 'wxhome'
    }
  },
  mounted(){
  },
  methods: {
    linkwxShow(name) {
      this.codeImg = name
      this.weixinDialogImg = true
    },
    weixinLink() {
      // window.location.href="weixin://";
      this.linkwxShow('wxhome')
    },
    copy(data){
      let url = data;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message.success('已成功复制文字');
      oInput.remove()
    },
    emailLink(){
      window.location.href='mailto:byepest@envu.com';
    },
    wikiLink(){
      this.$router.push({path: '/pest_wiki'})
    },
    dialogShowTip(){
      this.$parent.$refs.footerer.$emit('contactUs')
    },
    weixinLinkzx() {
      this.$parent.$refs.header.weixinLink()
    },
    sqLink() {
      this.$parent.$refs.header.codeModalShow = true
    },
    tel(){
      window.location.href='tel:4001888282';
      let url = this.$route.path;

      let _arr = [
        {
          name: '常见虫害',
          nameEn: 'commonpest',
        },
        {
          name: '白蚁专区',
          nameEn: 'termite',
        },
        {
          name: '别墅除虫',
          nameEn: 'villapest',
        },
        {
          name: '商业除虫',
          nameEn: 'enterprise',
        },
        {
          name: '品牌故事',
          nameEn: 'about',
        },
        {
          name: '用户评价',
          nameEn: 'evaluate',
        },
        {
          name: '虫害百科',
          nameEn: 'pest_wiki',
        },
      ]
      let _name = '首页'

      _arr.forEach(function(item,index){
        if(url.indexOf(item.nameEn) != -1) {
          _name = item.name
          return
        }
      });

      this.$ga.callnavigatorTel(_name);
    },
    linkabout(){
      if(this.isPhoneSize){
        this.$router.push({path: "/about"})
      }else{
        this.dialogShowTip()
      }
    },
    linkRouter(name){
      this.$router.push({path: name})
    },
    menulink(name){
      if(this.isPhoneSize){
        this.$router.push({path: "/category/" + name})
      }else{
        this.dialogShowTip()
      }
    },
    toBLink(){
      this.$router.push({name: 'Enterprise'})
    },
    Pageview(name = ''){
       let self = this;
       if(!name){
         self.$ga.Pageview(self.$rootUrl + this.$router.history.current.fullPath);
       }else{
         self.$ga.Pageview(name)
       }
    },
    navigatorBot(name){
      let self = this;
      self.$ga.navigatorBot(name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue